export const mediaqueries = {
  mobile: "(max-width: 720px)",
  tablet: "(min-width: 960px)",
  desktop: "(min-width: 1201px)",
  xl: "(min-width: 1601px)",
  xxl: "(min-width: 1920px)",
} as const;

export type MediaQueryBreakpoints = keyof typeof mediaqueries;
